import { useMediaQuery } from '@monofront/business/hooks';
import { productService } from '@services/businessContainer';
import CTA from '@screens/ProductDeprecated/Main/Info/CTA';
import {
  AddToShoppingCartSource,
  IPost,
  IProduct,
  ISearchProduct,
} from '@monofront/types';
import { useEffect, useState } from 'react';
import HeartLoader from '@monofront/design-system/components/HeartLoader';
import Drawer from '@monofront/design-system/components/Drawer';

interface IProductDrawerProps {
  product: IProduct | ISearchProduct;
  isOpen: boolean;
  productHandle: string;
  externalToggle?: () => void;
}

interface IProductWithTips {
  product?: IProduct;
  tips?: IPost[];
}

export const ProductDrawer: React.FC<IProductDrawerProps> = ({
  isOpen,
  externalToggle,
  product: { handle },
}) => {
  const isMobile = useMediaQuery(800);
  const [data, setData] = useState<IProductWithTips>();

  useEffect(() => {
    const fetchProduct = async () => {
      const { tips, product } = await productService.getProductWithTips(handle);

      setData({
        product: product,
        tips: tips?.length ? tips : undefined,
      });
    };

    if (isOpen) {
      fetchProduct();
    }
  }, [isOpen, handle]);

  return (
    <>
      <Drawer
        anchor="bottom"
        isOpen={isOpen}
        externalToggle={externalToggle}
        portalSelector={isMobile ? 'main' : '#__next'}
      >
        <div className="tw-pt-8">
          {!data?.product ? (
            <HeartLoader />
          ) : (
            <>
              {/* TODO : implements new product page from apps/ecommerce/src/screens/Product/Product.tsx */}
              {/* <Product product={data.product} tips={data.tips} /> */}
              <div className="sticky-cta">
                <CTA
                  product={data.product}
                  isSticky
                  addToShoppingCartContext={{
                    source: AddToShoppingCartSource.CHECKOUT_SUGGESTION,
                  }}
                />
              </div>
            </>
          )}
        </div>
      </Drawer>
      <style jsx>{`
        .sticky-cta {
          position: sticky;
          z-index: var(--zindex-sticky);
          bottom: env(safe-area-inset-bottom);
        }

        .sticky-cta > :global(div) {
          border-top-right-radius: var(--rd-5);
          border-top-left-radius: var(--rd-5);
          background-color: var(--clr-primary-5);
          padding: var(--space-2) var(--padding-layout-horizontal-sm);
        }
      `}</style>
    </>
  );
};

export default ProductDrawer;
